import styled from 'styled-components';
import { Form } from '@unform/web';

export const Filter = styled(Form)`
  padding: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  display: flex;
  align-items: center;
  justify-content: space-between;

  .pay_status,
  .situation,
  .drawee {
    width: 33%;
  }

  .type {
    width: 20%;
  }

  > div + div {
    margin-left: 16px;
  }

  button {
    border: 0;
    background: transparent;
    margin: 0 16px;
    transition: opacity 0.2s;
    width: 4%;

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }

    svg {
      color: ${({ theme }) => theme.colors.primary};
      height: 20px;
      width: 20px;
    }
  }
`;

export const Content = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;

  .table {
    .situation {
      width: 20%;
    }
  }

  .id {
    padding-left: 8px;
  }

  .expiration_day {
    width: 10%;
  }

  .financial_data {
    width: 20%;
  }

  .drawee {
    width: 35%;
  }

  .price_list {
    width: 10%;
    text-align: right;
  }
`;

export const BilletInfo = styled.div`
  display: flex;
  flex-direction: column;

  .finance_header,
  .situation_header {
    margin-top: 10px;
  }

  .expiration_day,
  .emission_day,
  .emition_day,
  .price,
  .interest,
  .interest_type,
  .fine,
  .fine_type,
  .days_to_fine {
    width: 10%;
  }

  .expiration_type,
  .species {
    width: 15%;
  }

  .protest,
  .how_to_charge {
    width: 25%;
  }

  .drawee,
  .finance_name_label,
  .financial_data,
  .situation_text {
    width: 35%;
  }

  .employee_limit {
    width: 10%;
  }

  .message,
  .obs,
  .billet_url {
    width: 100%;
  }
`;

export const Feedback = styled(Form)`
  margin-top: 16px;

  display: flex;
  flex-direction: column;

  section {
    align-items: flex-end;
  }
`;

export const FeedbackItem = styled.section`
  margin-top: 16px;
  position: relative;

  display: flex;

  div {
    display: flex;
    flex-direction: column;

    label {
      font-size: 12px;
      color: ${({ theme }) => theme.colors.grey};
      opacity: 0.7;
    }

    input {
      height: 30px;
      border-bottom: 1px solid ${({ theme }) => theme.colors.lightBorder};
      background: transparent;
    }

    textarea {
      resize: unset;
      background: transparent;
      border: 0px;
      border-bottom: 1px solid ${({ theme }) => theme.colors.lightBorder};
      margin-top: 8px;
    }

    button {
      background: none;
      margin-right: 8px;
      padding: 2px;
      transition: color 0.2s;
      color: ${({ theme }) => theme.colors.error};

      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        color: ${({ theme }) => theme.hover.error};
      }
    }
  }

  div + div {
    margin-left: 16px;
  }

  .delete {
    height: 40px;
    padding-top: 20px;

    display: flex;
    justify-content: center;
  }

  .date {
    margin-left: 0;
    width: 15%;
  }

  .user {
    width: 15%;
  }

  .file {
    flex: 1;

    display: flex;
    flex-direction: row;
    align-items: center;

    > aside {
      display: flex;
      flex-direction: column;

      button {
        background: none;
        color: ${({ theme }) => theme.colors.blue};
        padding: 2px;
        transition: color 0.2s;

        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          opacity: ${({ theme }) => theme.hover.blue};
        }
      }
    }

    > div {
      flex: 1;

      margin-left: 8px;
    }
  }

  .content {
    width: 40%;
  }
`;
